import styled from "styled-components";
import { Typography } from "./Typography";

/**
 * [共通パーツ]タイトル
 */

type Props = {
  text: string;
};

const Container = styled.div`
  display: flex;
`;

const Bar = styled.div`
  background-color: ${(props) => props.theme.colors.brand};
  width: 6px;
  border-radius: 6px;
  margin-right: 8px;
`;

export function Title(props: Props) {
  const { text } = props;
  return (
    <Container>
      <Bar />
      <Typography size={3} bold>
        {text}
      </Typography>
    </Container>
  );
}
